const getResultsByIndex = (allSearchResults, indexName)=>{
    var // this is an array of all search results and we might have multiple results for the same index
    // so we need to find the latest result for our index
    ref;
    var ref1;
    return (ref1 = (ref = allSearchResults.slice().reverse().find((searchResult)=>searchResult.indexId === indexName
    )) === null || ref === void 0 ? void 0 : ref.results) !== null && ref1 !== void 0 ? ref1 : null;
};

export { getResultsByIndex };
//# sourceMappingURL=get-results-by-index.js.map
